// rg-gallery-height: en mobile, las primeras 2 fotos del carrusel de producto
// miden la mitad de ancho (ver .rg-media-pair en base.css), asi que quedan
// mas cortas que el resto. El contenedor del carrusel no se achica solo
// (flexbox no reduce el alto de sus hermanos por defecto), asi que esta
// pieza ajusta el alto del contenedor a la diapositiva que esta centrada en
// pantalla en este momento, para que los botones de compra (que van debajo)
// suban o bajen segun corresponda.
//
// No depende de eventos propios del componente del carrusel del tema (su
// nombre/timing exacto no esta garantizado) -- calcula directamente, a
// partir de la posicion real de scroll, cual diapositiva esta centrada.
// Esto es exactamente lo que pasa cuando alguien desliza con el dedo.
//
// rg (2026-09-16, ronda 3): bug real reportado varias veces -- la foto
// quedaba colapsada/en blanco al hacer scroll. Las rondas 1 y 2 (debounce +
// bloqueo mientras el dedo esta apoyado) no lo resolvieron. Investigando mas
// a fondo: la version anterior NO media el alto real de la diapositiva --
// lo RE-CALCULABA con una formula propia (ancho asumido segun si es
// "rg-media-pair" o no, dividido por un ratio leido de una variable CSS).
// Esa formula puede desincronizarse de lo que el CSS real termina
// dibujando (por eso el codigo viejo evitaba medir el alto real -- ver
// comentario de "max-height: 100%" mas abajo -- pero terminaba adivinando
// en vez de medir). Se reemplaza por una medicion directa: se libera
// momentaneamente la altura fijada (para no quedar atrapado por el propio
// limite que pusimos la vez anterior), se mide el alto real que el
// navegador ya calculo para esa diapositiva, y se vuelve a fijar. No hay
// formula que se pueda desincronizar: es exactamente lo que el CSS real
// decidio.
(function () {
  var MOBILE_QUERY = '(max-width: 749px)';

  // Diapositiva cuyo centro esta mas cerca del centro del contenedor visible.
  function centeredSlide(scroller, slides) {
    var scrollerRect = scroller.getBoundingClientRect();
    var target = scrollerRect.left + scrollerRect.width / 2;
    var best = null;
    var bestDistance = Infinity;

    for (var i = 0; i < slides.length; i++) {
      var rect = slides[i].getBoundingClientRect();
      if (rect.width === 0) continue;
      var slideCenter = rect.left + rect.width / 2;
      var distance = Math.abs(slideCenter - target);
      if (distance < bestDistance) {
        bestDistance = distance;
        best = slides[i];
      }
    }

    return best;
  }

  // El propio slide tiene "max-height: 100%" (se ajusta al alto que ya
  // tenga el contenedor) -- si se mide directamente sin soltar antes esa
  // altura fijada, siempre devuelve la altura VIEJA, nunca la que en
  // realidad le corresponde a esta diapositiva. Se libera la altura del
  // contenedor a "auto" un instante (deja que el CSS real -- aspect-ratio,
  // object-fit, lo que sea -- decida el alto natural), se mide, y se vuelve
  // a fijar. Es una sola lectura de layout adicional, solo cuando el scroll
  // ya se asento (no en cada frame), asi que el costo es despreciable.
  function medirAltoNatural(scroller, slide) {
    var alturaPrevia = scroller.style.height;
    scroller.style.height = 'auto';
    var altura = slide.getBoundingClientRect().height;
    scroller.style.height = alturaPrevia;
    return altura;
  }

  // rg (2026-09-16): bug real reportado -- al hacer scroll vertical de la
  // pagina y tocar por accidente la foto, el carrusel horizontal a veces
  // dispara un "scroll" espurio (ambiguedad de gesto de iOS al tocar un
  // contenedor con overflow-x:scroll durante un swipe vertical). Si el
  // calculo de altura corria justo en ese momento -- mientras el navegador
  // todavia esta resolviendo a que diapositiva quedo el scroll -- podia
  // fijar una altura incorrecta. Se agrega un seguro, ademas del debounce
  // que ya existia: mientras el dedo este apoyado en la pantalla (en
  // cualquier parte, no solo en la galeria), no se toca la altura -- se
  // recalcula recien al soltar. Es imperceptible (el ajuste de altura no es
  // urgente) y elimina esa ventana de interferencia por completo.
  var rgDedoApoyado = false;
  document.addEventListener('pointerdown', function () {
    rgDedoApoyado = true;
  });
  document.addEventListener('pointerup', function () {
    rgDedoApoyado = false;
  });
  document.addEventListener('pointercancel', function () {
    rgDedoApoyado = false;
  });

  function init(gallery) {
    var scroller = gallery.querySelector('slideshow-slides');
    if (!scroller) return;
    // rg (2026-10-06): init() puede correr varias veces sobre el mismo DOM (ver observer en
    // start()); cada carrusel se inicializa una sola vez.
    if (scroller.__rgAltoInit) return;
    scroller.__rgAltoInit = true;

    var slides = Array.prototype.slice.call(scroller.querySelectorAll('slideshow-slide'));
    if (slides.length < 2) return;

    function update() {
      if (rgDedoApoyado) return;
      var slide = centeredSlide(scroller, slides);
      if (!slide) return;
      var altura = medirAltoNatural(scroller, slide);
      if (altura > 0) {
        scroller.style.height = altura + 'px';
      }
    }

    // Importante: NO recalcular en cada evento de scroll mientras el dedo
    // todavia esta deslizando -- cambiar el alto del contenedor a mitad de
    // gesto interfiere con el calculo nativo de "a que diapositiva hacer
    // snap", y el swipe se pasaba de largo. Se espera a que el scroll se
    // asiente del todo antes de ajustar el alto.
    var settleTimer = null;

    function scheduleUpdate() {
      if (settleTimer) clearTimeout(settleTimer);
      settleTimer = setTimeout(function () {
        settleTimer = null;
        update();
      }, 120);
    }

    update();

    if ('onscrollend' in window) {
      scroller.addEventListener('scrollend', scheduleUpdate, { passive: true });
    } else {
      scroller.addEventListener('scroll', scheduleUpdate, { passive: true });
    }

    // rg: si el dedo se levanta y habia quedado pendiente un recalculo
    // bloqueado por rgDedoApoyado (ej. "scrollend" disparo con el dedo
    // todavia apoyado), se reintenta una vez al soltar.
    document.addEventListener('pointerup', scheduleUpdate, { passive: true });

    window.addEventListener('resize', scheduleUpdate);
  }

  function scan(root) {
    root.querySelectorAll('.product-information__media media-gallery').forEach(init);
  }

  function start() {
    if (!window.matchMedia(MOBILE_QUERY).matches) return;
    scan(document);

    // rg (2026-10-06): bug real -- al elegir una talla el tema hace media-gallery.replaceWith(<nuevo>)
    // (assets/media-gallery.js, #handleVariantUpdate). El carrusel nuevo no tiene el alto fijado por
    // este script ni sus listeners, asi que las 2 primeras fotos (mitad de alto) quedaban en un
    // contenedor de alto completo: foto cortada arriba y un hueco negro enorme hasta los botones.
    // Se observa el contenedor (que no se reemplaza) y se inicializa cada galeria nueva.
    var container = document.querySelector('.product-information__media');
    if (!container || !window.MutationObserver) return;
    var pendiente = false;
    new MutationObserver(function () {
      if (pendiente) return;
      pendiente = true;
      requestAnimationFrame(function () {
        pendiente = false;
        scan(document);
      });
    }).observe(container, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
